import {
  ChakraProvider,
  Heading,
  theme,
  useColorModeValue,
  VStack,
} from "@chakra-ui/react";
import { Nav, SwapUI } from "./components";

export const App = () => (
  <VStack w="full" style={{ 
    backgroundImage: `url("https://images.unsplash.com/photo-1490682143684-14369e18dce8?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80")`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover' 
  }}>
    <Nav />
    <VStack w="full" minH={"100vh"} pt={20}>
      <SwapUI />
    </VStack>
  </VStack>
);